export interface Testimonial {
  company: string;
  name: string;
  position: string;
  country: string;
  badge: string;
  rating: number;
  quote: string;
}

export const testimonialsRow1: Testimonial[] = [
  {
    company: 'Webleez Limited',
    name: 'Mr Omar Faruk',
    position: 'CEO',
    country: 'Bangladesh',
    badge: 'Software & Web',
    rating: 5,
    quote:
      "Jit's leadership in product strategy and full-stack engineering execution completely transformed our web platform delivery. He bridges business goals and complex technical architecture effortlessly.",
  },
  {
    company: 'Chemier Boiler LLC',
    name: 'Mr Andres',
    position: 'Chairman',
    country: 'Spain',
    badge: 'Industrial Systems',
    rating: 5,
    quote:
      'Working with Jit was an exceptional experience. He delivered a robust, high-performance system for our international operations with great attention to detail and zero downtime.',
  },
  {
    company: 'Vision Ads 460 Ltd',
    name: 'Mr Forhad Hossain',
    position: 'Director',
    country: 'Bangladesh',
    badge: 'Digital Advertising',
    rating: 5,
    quote:
      "From day one, Jit understood our scale and commercial targets. The digital systems and automation pipelines he deployed increased our team's operational velocity by more than 3x.",
  },
  {
    company: 'CloudScale SaaS',
    name: 'Marcus Vance',
    position: 'CEO & Founder',
    country: 'United States',
    badge: 'B2B SaaS Platform',
    rating: 5,
    quote:
      'Jit restructured our entire discovery-to-delivery cadence in six weeks. We went from chaotic weekly debates to shipping high-conviction features on time with clear unit economics.',
  },
];

export const testimonialsRow2: Testimonial[] = [
  {
    company: 'Dew Butterflies',
    name: 'Mr Farhan Ahmed',
    position: 'Founder',
    country: 'Bangladesh',
    badge: 'E-Commerce',
    rating: 5,
    quote:
      'Jit brings clarity, passion, and elite technical skill to everything he touches. He helped us shape our digital presence and commerce experience with absolute precision.',
  },
  {
    company: 'Jamal Al Sham Perfumes & Cosmetics Trading LLC',
    name: 'Mr Farhan Ahmed',
    position: 'Managing Director',
    country: 'United Arab Emirates',
    badge: 'Retail & Trading',
    rating: 5,
    quote:
      'His ability to build scalable e-commerce systems and integrate modern automated workflows helped expand our cross-border retail operations across the GCC smoothly.',
  },
  {
    company: 'ApexByte Technologies',
    name: 'Mr Rajesh Sharma',
    position: 'Founder & Director',
    country: 'India',
    badge: 'Enterprise Tech',
    rating: 5,
    quote:
      'Jit demonstrated exceptional patience throughout the project, successfully delivering it on time despite encountering technical challenges. I commend his efforts and would definitely consider hiring him again for future projects.',
  },
  {
    company: 'Finova Digital',
    name: 'David Chen',
    position: 'VP of Product',
    country: 'Singapore',
    badge: 'Fintech & Wealth',
    rating: 5,
    quote:
      'Having Jit as our fractional Head of Product eliminated 35% of roadmap bloat and helped us secure our Series A with clear, verifiable product metrics.',
  },
];
